<template>
  <div
    v-click-outside="onClickOutside"
    class="tooltip"
    :class="{ clicked: clicked }"
  >
    <btn-tooltip
      target="mailNoticeTooltip"
      class="-question"
      @click="onClickBtnTooltip"
    />
    <span class="tooltip-text">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import BtnTooltip from "@/components/button/BtnTooltip";
import vClickOutside from "click-outside-vue3";

export default {
  name: "TooltipsItem",
  components: {
    BtnTooltip,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data: () => {
    return {
      clicked: false,
    };
  },
  methods: {
    onClickOutside() {
      this.clicked = false;
    },
    onClickBtnTooltip() {
      this.clicked = true;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/stylesheets/styles";

.tooltip {
  position: absolute;
  bottom: 0;
  right: 0;

  &:hover .tooltip-text,
  &.clicked .tooltip-text {
    display: block;
  }
}
.tooltip-text {
  position: absolute;
  display: none;
  background-color: $light;
  padding: 10px;
  border: 1px solid #cccccc;
  border-radius: 10px;
  text-align: left;
  font-size: 12px;
  line-height: 22px;
  z-index: 1;

  @include mq-down(md) {
    top: 4px !important;
    right: -10px !important;
    width: 80vw;
  }

  @include mq-up(md) {
    top: -61px !important;
    left: 14px !important;
    width: 63vw;
    max-width: 600px;
    min-height: 77px;
    padding: 20px 30px;
    border-radius: 20px;
    font-size: 14px;
  }

  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border: solid transparent;
    pointer-events: none;

    @include mq-down(md) {
      bottom: 100%;
      right: 25px;
    }
  }

  &:before {
    margin-bottom: 1px;
    margin-left: -7px;
    border-color: rgba(204, 204, 204, 0);
    border-bottom-color: #cccccc;
    border-top-width: 11px;
    border-bottom-width: 11px;
    border-left-width: 7px;
    border-right-width: 7px;

    @include mq-up(md) {
      top: 29px;
      left: -37px;
      border-color: rgba(204, 204, 204, 0);
      border-right-color: #cccccc;
      border-left-width: 22px;
      border-right-width: 22px;
    }
  }

  &:after {
    margin-left: -6px;
    border-color: rgba(245, 245, 245, 0);
    border-bottom-color: #f5f5f5;
    border-top-width: 10px;
    border-bottom-width: 10px;
    border-left-width: 6px;
    border-right-width: 6px;

    @include mq-up(md) {
      top: 30px;
      left: -33px;
      border-color: rgba(245, 245, 245, 0);
      border-right-color: #f5f5f5;
      border-left-width: 20px;
      border-right-width: 20px;
    }
  }
}
</style>
